import * as actionTypes from '../actions/actionTypes'
import moment from 'moment'
const initialState = {
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  records: [],
  company: [],
  resultType: [],
  filterForceRankGroup: [],
  filterLoading: false,
  selectedRecord: null,
  loadingStates: [],
  gradeData: []
}

const fetchForceRankGroupStart = (state, action) => {
  return { ...state, loading: true, loadingStates: [...state.loadingStates, 'record'] }
}

const fetchForceRankGroupSuccess = (state, action) => {
  let { pagination, records } = action

  records = records.map(res => {
    let data = res
    return {
      ...data,
      company_name: data?.company?.company_name
    }
  })
  return {
    ...state,
    records: records,
    loading: false,
    loadingStates: state.loadingStates.filter(item => item !== 'record'),
    pagination: pagination
  }
}

const fetchForceRankGroupFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    loadingStates: state.loadingStates.filter(item => item !== 'record'),
    message: action.errorMessage
  }
}

const fetchCompanyStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchCompanySuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    company: action.data
  }
}

const fetchCompanyFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchResultTypeStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchResultTypeSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    resultType: action.data
  }
}

const fetchResultTypeFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const createForceRankGroupStart = (state, action) => {
  return { ...state, loading: true }
}

const createForceRankGroupSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const createForceRankGroupFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const updateForceRankGroupStart = (state, action) => {
  return { ...state, loading: true }
}

const updateForceRankGroupSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const updateForceRankGroupFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const deleteForceRankGroupStart = (state, action) => {
  return { ...state, loading: true }
}

const deleteForceRankGroupSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const deleteForceRankGroupFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const fetchForceRankGroupByIdSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    selectedRecord: action.recordData,
    loadingStates: state.loadingStates.filter(item => item !== 'record')
  }
}

const clearSelectedForceRankGroupRecord = (state, action) => {
  return {
    ...state,
    selectedRecord: { effective_date: moment(new Date(), 'YYYY-MM-DD').format('DD MMM YYYY') },
    success: false
  }
}

const fetchForceRankGradeStart = (state, action) => {
  return {
    ...state
    // filtered: true
  }
}

const fetchForceRankGradeSuccess = (state, action) => {
  return {
    ...state,
    // filtered: true,
    gradeData: action.data
  }
}

const fetchForceRankGradeFailed = (state, action) => {
  return {
    ...state
    // filtered: false,
    // message: action.errorMessage
  }
}

const fetchForceRankGroupFilterForceRankGroupStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchForceRankGroupFilterForceRankGroupSuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterForceRankGroup: action.data
  }
}

const fetchForceRankGroupFilterForceRankGroupFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_FORCE_RANK_GROUP_START:
      return fetchForceRankGroupStart(state, action)
    case actionTypes.FETCH_FORCE_RANK_GROUP_SUCCESS:
      return fetchForceRankGroupSuccess(state, action)
    case actionTypes.FETCH_FORCE_RANK_GROUP_FAILED:
      return fetchForceRankGroupFailed(state, action)
    case actionTypes.CREATE_FORCE_RANK_GROUP_START:
      return createForceRankGroupStart(state, action)
    case actionTypes.CREATE_FORCE_RANK_GROUP_SUCCESS:
      return createForceRankGroupSuccess(state, action)
    case actionTypes.CREATE_FORCE_RANK_GROUP_FAILED:
      return createForceRankGroupFailed(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_START:
      return fetchCompanyStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS:
      return fetchCompanySuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FAILED:
      return fetchCompanyFailed(state, action)
    case actionTypes.FETCH_RESULT_TYPE_OPTIONS_START:
      return fetchResultTypeStart(state, action)
    case actionTypes.FETCH_RESULT_TYPE_OPTIONS_SUCCESS:
      return fetchResultTypeSuccess(state, action)
    case actionTypes.FETCH_RESULT_TYPE_OPTIONS_FAILED:
      return fetchResultTypeFailed(state, action)

    case actionTypes.UPDATE_FORCE_RANK_GROUP_START:
      return updateForceRankGroupStart(state, action)
    case actionTypes.UPDATE_FORCE_RANK_GROUP_SUCCESS:
      return updateForceRankGroupSuccess(state, action)
    case actionTypes.UPDATE_FORCE_RANK_GROUP_FAILED:
      return updateForceRankGroupFailed(state, action)
    case actionTypes.DELETE_FORCE_RANK_GROUP_START:
      return deleteForceRankGroupStart(state, action)
    case actionTypes.DELETE_FORCE_RANK_GROUP_SUCCESS:
      return deleteForceRankGroupSuccess(state, action)
    case actionTypes.DELETE_FORCE_RANK_GROUP_FAILED:
      return deleteForceRankGroupFailed(state, action)
    case actionTypes.FETCH_FORCE_RANK_GROUP_BY_ID_SUCCESS:
      return fetchForceRankGroupByIdSuccess(state, action)
    case actionTypes.CLEAR_SELECTED_FORCE_RANK_GROUP_RECORD:
      return clearSelectedForceRankGroupRecord(state, action)
    case actionTypes.FETCH_GRADE_OPTIONS_START:
      return fetchForceRankGradeStart(state, action)
    case actionTypes.FETCH_GRADE_OPTIONS_SUCCESS:
      return fetchForceRankGradeSuccess(state, action)
    case actionTypes.FETCH_GRADE_OPTIONS_FAILED:
      return fetchForceRankGradeFailed(state, action)
    case actionTypes.FETCH_FORCE_RANK_GROUP_FILTER_FORCE_RANK_GROUP_START:
      return fetchForceRankGroupFilterForceRankGroupStart(state, action)
    case actionTypes.FETCH_FORCE_RANK_GROUP_FILTER_FORCE_RANK_GROUP_SUCCESS:
      return fetchForceRankGroupFilterForceRankGroupSuccess(state, action)
    case actionTypes.FETCH_FORCE_RANK_GROUP_FILTER_FORCE_RANK_GROUP_FAILED:
      return fetchForceRankGroupFilterForceRankGroupFailed(state, action)
    default:
      return state
  }
}

export default reducer
